import { render, staticRenderFns } from "./Trazim.vue?vue&type=template&id=4708e268&"
import script from "./Trazim.vue?vue&type=script&lang=js&"
export * from "./Trazim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports